<template>
  <div class="container-box">
    <h2 class="title-type-1">
      캠페인 관리
      <v-tooltip right content-class="tooltip-custom-1">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="ico-help-1" v-bind="attrs" v-on="on">mdi-help</v-icon>
        </template>
        <span
          >VX의 모든 캠페인(광고집행건)을 생성, 수정 관리하는 중요한 메뉴
          화면입니다.</span
        >
      </v-tooltip>
    </h2>

    <div class="search-box-2">
      <div class="form-row-1">
        <p class="label">조회 기간</p>
        <div class="write-con d-flex align-center">
          <div class="datepicker-type-1">
            <v-icon>mdi-calendar-blank</v-icon>
            <date-range-picker
              v-model="dateRange"
              :locale-data="localeData"
              opens="right"
              @update="updateDateRange"
            ></date-range-picker>
          </div>
          <div class="ml-2">
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              min-width="104px"
              class="button-type-1"
              @click.prevent="registerReportAdmin"
            >
              조회
            </v-btn>
          </div>
        </div>
      </div>

      <a
        href=""
        class="arrow"
        :class="{ active: searchCell }"
        @click.prevent="searchCell = !searchCell"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </a>

      <v-expand-transition>
        <div v-if="searchCell">
          <div class="form-row-1 mt-5">
            <p class="label pt-0">캠페인 상태</p>
            <div class="write-con">
              <v-radio-group v-model="filterStatus" row hide-details>
                <v-radio
                  label="전체"
                  value="all"
                  color="#fecd00"
                  class="radio-type-1"
                ></v-radio>
                <v-radio
                  label="대기중"
                  value="0"
                  color="#fecd00"
                  class="radio-type-1"
                  name="radio"
                  hide-details
                ></v-radio>
                <v-radio
                  label="진행중"
                  value="1"
                  color="#fecd00"
                  class="radio-type-1"
                  name="radio"
                  hide-details
                ></v-radio>
                <v-radio
                  label="종료"
                  value="2"
                  color="#fecd00"
                  class="radio-type-1"
                  name="radio"
                  hide-details
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
          <div class="form-row-1 mt-4">
            <p class="label">집행 매체</p>
            <div class="write-con">
              <div>
                <v-btn
                  depressed
                  max-height="32px"
                  :color="
                    mediaLists.length !== mediaListsCheck.length
                      ? '#fecd06'
                      : '#eee'
                  "
                  class="button-type-1"
                  @click.prevent="onCheckAll"
                >
                  {{
                    mediaLists.length !== mediaListsCheck.length
                      ? '전체 선택'
                      : '선택 해제'
                  }}
                </v-btn>
              </div>
              <ul class="chx-list-type-1 five mt-2">
                <li v-for="(media, index) in mediaLists" :key="index">
                  <v-checkbox
                    v-model="mediaListsCheck"
                    :value="media.id"
                    :label="media.name"
                    color="#fecd00"
                    off-icon="mdi-checkbox-blank"
                    class="checkbox-type-1"
                    hide-details
                  >
                  </v-checkbox>
                </li>
              </ul>
            </div>
          </div>
          <div class="form-row-1 mt-4">
            <p class="label">광고주/대행사</p>
            <div class="write-con d-flex align-center">
              <div class="search-1">
                <span class="readinput">
                  <v-text-field
                    class="input-custom-2"
                    height="40px"
                    max-width="100px"
                    v-model="adviertierName"
                    hide-details
                    solo
                    readonly
                    @click.prevent="openPopup"
                  ></v-text-field>
                </span>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fecd06"
                  class="button-type-1 ml-2"
                  @click.prevent="openPopup"
                >
                  찾기
                </v-btn>
                <v-btn
                  depressed
                  large
                  max-height="40px"
                  color="#fff"
                  class="button-type-1 ml-2"
                  @click.stop="adviertierCancel"
                >
                  취소
                </v-btn>
              </div>
            </div>
          </div>
          <div class="form-row-1 mt-4">
            <p class="label">캠페인</p>
            <div class="write-con">
              <div class="search-box-1">
                <div class="search-1">
                  <div class="input relative">
                    <v-text-field
                      placeholder="캠페인명"
                      v-model="campaignName"
                      class="input-custom-2"
                      height="40px"
                      solo
                      @keypress="registerReportAdmin"
                    ></v-text-field>
                    <v-btn
                      icon
                      class="btn"
                      @click.prevent="registerReportAdmin"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-expand-transition>
    </div>
    <!-- //search-box-2-->

    <div class="mt-16">
      <div class="d-flex justify-space-between align-end mt-8 mb-8">
        <p class="text-total-1">
          총 <strong>{{ totalList }}</strong
          >건 입니다.
        </p>
        <v-btn
          large
          depressed
          max-height="40px"
          color="#fecd06"
          class="button-type-1"
          @click="goCampaignResisterPage"
        >
          <v-icon left> mdi-plus </v-icon>
          캠페인 등록
        </v-btn>
      </div>

      <div class="table-wrap">
        <v-data-table
          :headers="boardHeaders"
          :items="customBoardLists"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="board-list-1"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items, headers }">
            <tbody v-if="items.length > 0">
              <tr v-for="(item, index) in items" :key="index">
                <td>
                  {{ item.no }}
                </td>
                <td>
                  <router-link :to="`/campaign/${item.id}/modify`">
                    {{ item.name }}
                  </router-link>
                </td>
                <td>
                  {{ item.mediaNames || `-` }}
                </td>
                <td>
                  <span v-if="item.start_at && item.end_at">
                    {{ item.start_at | moment('YYYY.MM.DD') }}
                    ~
                    {{ item.end_at | moment('YYYY.MM.DD') }}
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  <div v-if="item.inventorisLen > 0">
                    <a href="" @click.prevent="inventorisCurrent(item)">
                      {{ item.inventorisLen }}
                    </a>
                  </div>
                  <div v-else>0</div>
                </td>
                <td>
                  {{ item.advertiser.name }}
                </td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  <v-switch
                    inset
                    color="#fecd00"
                    :input-value="item.is_valid === 'Y' ? true : false"
                    @change="saveLineItem($event, item)"
                    class="switch-type-1"
                    hide-details
                  ></v-switch>
                </td>
                <td>
                  {{ item.creator.manager_name || `-` }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td :colspan="headers.length" style="text-align: center">
                  검색결과가 없습니다.
                </td>
              </tr>
            </tbody>
          </template>
          <template v-slot:no-data>
            <div class="text-center">목록이 없습니다.</div>
          </template>
        </v-data-table>
      </div>

      <div class="pagination-1">
        <div class="sel-sort">
          <span>페이지당 행개수</span>
          <v-select
            :items="pageSel"
            :label="pageSel[0]"
            v-model="pageSelChoice"
            item-color="#000"
            class="input-custom-1"
            height="40px"
            solo
            @change="itemsPerPage = parseInt($event, 10)"
          ></v-select>
        </div>

        <v-btn
          icon
          :plain="true"
          :ripple="false"
          :disabled="page == 1"
          @click="page = 1"
        >
          <v-icon>mdi-page-first</v-icon>
        </v-btn>

        <v-pagination
          v-model="page"
          :length="pageCount"
          total-visible="10"
          color="transparent"
        ></v-pagination>

        <v-btn
          icon
          :plain="true"
          :ripple="false"
          :disabled="page == pageCount"
          @click="page = pageCount"
        >
          <v-icon>mdi-page-last</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="showInventorisCurrent">
      <CampaingToInventoryModal
        v-model="showInventorisCurrent"
        :propsCampaign="campaign"
      />
    </div>
    <SearchAdvertiserModal
      v-model="searchAdveriser"
      @select:advertiser="selectAdvertiser"
    />
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
    <SystemAlert v-model="showSystemAlert2">
      <div slot="noti-text" v-html="logResult2"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="closePopup2"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import SearchAdvertiserModal from '~@/modal/SearchAdvertiserModal.vue';
import CampaingToInventoryModal from '~@/modal/CampaignToInventoryModal.vue';

import SystemAlert from '~@/modal/SystemAlert.vue';
import bus from '@/utils/bus.js';

import { listMedia } from '@/api/media';
import { listCampaign, updateCampaign } from '@/api/campaign';
import { toISOFormattedDate } from '@/utils/validation';
import moment from 'moment';

let today = new Date();
today.setHours(0, 0, 0, 0);
today = moment(today);
let today2 = moment(today).add(1, 'months');

export default {
  components: {
    DateRangePicker,
    SearchAdvertiserModal,
    CampaingToInventoryModal,
    SystemAlert,
  },
  props: {
    checked: Boolean,
  },
  data: () => ({
    dateRange: {
      startDate: today,
      endDate: today2,
    },

    localeData: {
      format: `yyyy-mm-dd`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: '　~　',
    },
    showdetail: false,
    showInventorisCurrent: false,
    campaign: {},

    mediaLists: [],
    mediaListsCheck: [],

    searchCell: false,
    searchAdveriser: false,
    adviertierName: '',
    adviertierId: '',
    searchSel: [],
    searchSelChoice: '',
    campaignName: '',
    boardHeaders: [
      { text: 'NO', value: 'no', sortable: false },
      { text: '캠페인 명', value: 'name', width: '15%', sortable: false },

      { text: '집행 매체', value: 'medias', width: '20%', sortable: false },
      { text: '집행 기간', value: '', width: '16%', sortable: false },
      { text: '상품(지면)수', value: 'medias', width: '9%', sortable: false },
      {
        text: '광고주',
        value: 'advertiser.name',
        width: '13%',
        sortable: false,
      },
      { text: '캠페인상태', value: 'status', width: '7%', sortable: false },
      { text: '노출관리', value: 'is_valid', sortable: false },
      { text: '등록관리자', value: 'creator.manager_name', sortable: false },
    ],
    boardLists: [],
    customLists: [],
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    showSystemAlert: false,
    logResult: '',
    showSystemAlert2: false,
    logResult2: '',

    filterStatus: 'all',
  }),
  computed: {
    totalList() {
      let result = 0;
      if (this.boardLists.length > 0) {
        result = this.boardLists.length;
      }
      return result;
    },
    customBoardLists() {
      for (let num = 0; num < this.boardLists.length; num++) {
        let item = this.boardLists[num];
        item.no = this.boardLists.length - num;
        const mediaNamesArray = [];
        const inventorisInMedia = [];
        item.medias.map(media => {
          mediaNamesArray.push(media.name);
          media.inventories.forEach(inventory =>
            inventorisInMedia.push(inventory),
          );
        });
        item.mediaNames = mediaNamesArray.join(`, `);
        item.inventorisLen = inventorisInMedia.length;

        if (item.is_valid === 'Y') {
          if (this.$moment(item.start_at) > this.$moment(new Date())) {
            item.status = '대기중';
          } else if (this.$moment(item.end_at) > this.$moment(new Date())) {
            item.status = '진행중';
          } else {
            item.status = '종료';
          }
        } else {
          item.status = '종료';
        }
      }
      return this.boardLists;
    },
  },
  methods: {
    async getListMedia() {
      try {
        const { data } = await listMedia();
        const getListMedia = data.list;

        this.mediaLists = getListMedia;

        const mediaListCheck = getListMedia.reduce((previous, current) => {
          previous.push(current.id);
          return previous;
        }, []);

        this.mediaListsCheck = mediaListCheck;
        this.registerReportAdmin();
      } catch (error) {
        console.log(error.response);
      }
    },

    selectAdvertiser(data) {
      this.adviertierName = data.name;
      this.adviertierId = data.id;
    },
    openPopup() {
      this.searchAdveriser = true;
    },
    adviertierCancel() {
      this.adviertierName = '';
      this.adviertierId = '';
    },
    onCheckAll() {
      this.mediaLists.length <= this.mediaListsCheck.length
        ? (this.mediaListsCheck = [])
        : this.mediaLists.forEach(media => {
            this.mediaListsCheck.push(media.id);
          });
    },
    async registerReportAdmin() {
      try {
        let startDate = toISOFormattedDate(this.dateRange.startDate);
        let endDate = toISOFormattedDate(this.dateRange.endDate);

        const mediaLists = this.mediaListsCheck.reduce((previous, current) => {
          previous.push(current);
          return previous;
        }, []);

        if (this.mediaListsCheck <= 0) {
          this.showSystemAlert = true;
          this.logResult = '집행 매체를 최소 1개 선택해주세요.';
          return;
        }
        bus.$emit('start:spinner');

        const resultData = () => {
          const result = {
            start_at: startDate,
            end_at: endDate,
          };
          if (mediaLists.length > 0) result.medias = mediaLists.join(',');
          if (this.adviertierId) result.advertisers = this.adviertierId;
          if (this.campaignName) result.name = this.campaignName;
          if (this.filterStatus) {
            if (this.filterStatus !== 'all') {
              result.status = parseInt(this.filterStatus);
            }
          }
          return result;
        };

        const params = resultData();

        const { data } = await listCampaign({ params });

        if (data.list.length > 0) {
          this.boardLists = data.list;
        } else {
          this.showSystemAlert = true;
          this.logResult = '조회된 목록이 없습니다.';
          this.boardLists = [];
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    goCampaignResisterPage() {
      this.$router.push({ name: 'campaignRegister' }).catch(() => {});
    },

    async saveLineItem(event, item) {
      try {
        bus.$emit('start:spinner');
        const campaignId = item.id;
        let start_at = toISOFormattedDate(new Date(item.start_at));
        let end_at = toISOFormattedDate(new Date(item.end_at));

        let is_valid = item.is_valid === 'Y' ? 'N' : 'Y';

        let updateData = {
          is_valid: is_valid,
          start_at: start_at,
          end_at: end_at,
        };

        const { data } = await updateCampaign(campaignId, updateData);
        if (data.result === 'success') {
          this.showSystemAlert = true;
          this.logResult = '노출 설정을 변경하였습니다.';
          await this.getListMedia();
        }
      } catch (error) {
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          const dataList = data.list;
          let campaignNames = [];
          let inventoryNames = [];
          (dataList || []).forEach(item => {
            console.log('item', item);
            inventoryNames.push(item.inventory_name);
            item.campaigns.map(campaign => {
              campaignNames.push(campaign.name);
            });
          });
          console.log(campaignNames);
          console.log(inventoryNames);

          let resultCampaignNames = campaignNames.join(', ');
          let resultIventoryNames = inventoryNames.join(', ');

          this.showSystemAlert2 = true;
          this.logResult2 = `선택하신 캠페인에 포함된 상품(지면)중 <br> 현재 [ ${resultCampaignNames} ]<br> 캠페인에서 사용중인 지면<br> [ ${resultIventoryNames} ] 이(가) <br>포함되어 있습니다.<br><br>지면별 일정을 확인 / 수정후<br>다시 시도해주시기 바랍니다.`;
        } else if (data.result === 'OutRange') {
          this.showSystemAlert2 = true;
          this.logResult2 = `해당 캠페인에 속해있는 소재와 지면의 기간을 모두 포함해야 합니다. 기간 확인 후 다시 설정해주세요.`;
        } else {
          this.showSystemAlert = true;
          this.logResult = `수정 중 에러가 발생했습니다. 재시도 부탁드립니다.`;
        }
      }
    },
    updateDateRange() {
      this.dateRange.startDate.setHours(0, 0, 0, 0);
      this.dateRange.endDate.setHours(0, 0, 0, 0);
    },
    inventorisCurrent(campaign) {
      this.campaign = campaign;
      this.showInventorisCurrent = true;
    },
    closePopup() {
      this.showSystemAlert = false;
      this.logResult = '';
    },
    closePopup2() {
      bus.$emit('start:spinner');
      this.showSystemAlert2 = false;
      setTimeout(() => {
        location.reload();
      }, 100);
    },
  },
  created() {
    bus.$emit('start:spinner');
    this.getListMedia();
  },
};
</script>

<style></style>
